<template>
  <DialogWrapper
    close-on-cancel
    destroyOnClose
    class="ai-summary-dialog"
    :loading="isLoading"
    :titleI18nKey="`${i18nPrefix}.title.aiResumeSummarizer`"
    :show.sync="isShow"
  >
    <ContentTypewriterEffect
      :show="isShow"
      :content="displayContent"
      :isTypingEnabled="isTypingEnabled"
      @closeTyping="handleCloseTyping"
      @change="handleChange"
    ></ContentTypewriterEffect>
    <template #footer>
      <div class="dialog-footer">
        <el-button v-if="hasInviteHMPermission" class="footer-btn save-btn" :disabled="isTypingEnabled" @click="handleInviteHMRate">{{ $t(`${applicationI18nPrefix}.btn.action.inviteHMRating`) }}</el-button>
        <el-button v-if="hasInterviewPermission" class="footer-btn save-btn" :disabled="isTypingEnabled" @click="handleInviteHMInterview">{{ $t(`${applicationI18nPrefix}.btn.action.inviteInterview`) }}</el-button>
        <el-button class="footer-btn save-btn" :disabled="isTypingEnabled" @click="handleSave">{{ $t('common.btn.save') }}</el-button>
      </div>
    </template>
  </DialogWrapper>
</template>

<script>
import ContentTypewriterEffect from '@/components/common/text/contentTypewriterEffect.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'

export default {
  components: {
    DialogWrapper,
    ContentTypewriterEffect
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    isTypingEnabled: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      applicationI18nPrefix: 'admin.application.applicantList',
      displayContent: ''
    }
  },
  computed: {
    hasInviteHMPermission () {
      return this.hasAnyPermission(['PREMIUM_INVITE_HM_REVIEW', 'PERM_INVITE_HM_REVIEW'])
    },
    hasInterviewPermission () {
      return this.hasAnyPermission(['PREMIUM_INTERVIEW_SCHEDULING', 'PERM_HR_INTERVIEW_SCHEDULING'])
    },
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    },
    isLoading: {
      get () {
        return this.loading
      },
      set (val) {
        this.$emit('update:loading', val)
      }
    }
  },
  created () {

  },
  methods: {
    handleInviteHMRate () {
      this.isShow = false
      this.$emit('inviteHMRate')
    },
    handleInviteHMInterview () {
      this.isShow = false
      this.$emit('inviteHMInterview')
    },
    handleChange (content) {
      this.displayContent = content
      this.$emit('change', content)
    },
    handleSave () {
      this.isLoading = true
      this.$emit('save', this.displayContent, () => {
        this.isShow = false
        this.isLoading = false
      })
    },
    handleCloseTyping () {
      this.$emit('closeTyping', false)
    }
  },
  watch: {
    content () {
      this.displayContent = this.content
    },
    isShow () {
      if (this.isShow) {
        this.displayContent = this.content
      } else {
        this.displayContent = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ai-summary-dialog {
  .dialog-footer {
    .footer-btn  {
      border-radius: 2px;
      padding: 10px 30px;
    }

    .save-btn {
      background: #0096cc;
      border-color: #0096cc;
      color: #ffffff;
    }

    .cancel-btn {
      background: #ffffff;
      color: #606266;
    }
  }
}
</style>
